import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { CATEGORIES } from "@/lib/categories";

export const GoalDialog = ({ goal, onSave, children, testId }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ title: "", notes: "", target_date: "", category: "" });

  const onOpen = (o) => {
    if (o) setF({ title: goal?.title || "", notes: goal?.notes || "", target_date: goal?.target_date || "", category: goal?.category || "", ...(goal?.done ? { completed_at: goal.completed_at || "" } : {}) });
    setOpen(o);
  };
  const submit = async (e) => {
    e.preventDefault();
    if (!f.title.trim()) return;
    await onSave({ ...f, title: f.title.trim() });
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-w-md" data-testid={testId}>
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{goal ? "Edit goal" : "Before I die, I want to…"}</DialogTitle>
          <DialogDescription>Write it down. That's step one.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input autoFocus placeholder="e.g. Swim with whale sharks" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="goal-title-input" />
          <Textarea placeholder="Notes (optional)" rows={3} value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} data-testid="goal-notes-input" />
          <div>
            <p className="text-xs text-slate-400 mb-1.5">Category</p>
            <div className="flex flex-wrap gap-1.5">
              {CATEGORIES.map((c) => {
                const on = f.category === c.key;
                return (
                  <button type="button" key={c.key} onClick={() => setF({ ...f, category: on ? "" : c.key })} data-testid={`goal-category-${c.key}`}
                    className="px-2.5 py-1 rounded-full text-xs border transition-colors duration-200"
                    style={on ? { background: c.color, borderColor: c.color, color: "#0B0F17" } : { borderColor: `${c.color}55`, color: c.color }}>
                    {c.label}
                  </button>
                );
              })}
            </div>
          </div>
          <label className="block text-xs text-slate-400">
            Target date (optional)
            <Input type="date" className="mt-1 [color-scheme:dark] font-mono" value={f.target_date} onChange={(e) => setF({ ...f, target_date: e.target.value })} data-testid="goal-date-input" />
          </label>
          {goal?.done && (
            <label className="block text-xs text-slate-400">
              Completed on
              <Input type="date" className="mt-1 [color-scheme:dark] font-mono" value={f.completed_at || ""} onChange={(e) => setF({ ...f, completed_at: e.target.value })} data-testid="goal-completed-input" />
            </label>
          )}
          <DialogFooter>
            <Button type="submit" className="bg-rose-400 text-[#1f0a0e] hover:bg-rose-300" data-testid="goal-save-button">{goal ? "Save" : "Add to my list"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
